export const NS_info = {
  Client_Policy_Premium_Coverage_Info: `<DIV id="page_2">
    <P class="p-left content"><span class="content-bold-underline">MassMutual Whole Life {{PRODUCT}}{{WithCir}}</span> is a permanent life insurance policy providing a guaranteed face amount{{CirNSText}}. Premiums are {{PRODUCT_PAYABLE_COPY}}. This illustration is neither a projection nor estimate of future benefits and assumes that the currently illustrated non-guaranteed elements will continue unchanged for all years shown. This is not likely to occur. Actual results may be more or less favorable than those shown.</P>
    <TABLE id="page-table_1" class="full-width page-table" cellpadding=0 cellspacing=0>
    {{LowerDividendWarning}}
    <TR>
        <TD colspan=2><P class="p-center sub-heading-center nobr">Client Information</P></TD>
    </TR>
    <TR>
        <TD><P class="p-left content">Prepared for</P></TD>
        <TD><P class="p-right content nobr">{{ClientFirstName}} {{ClientLastName}}, {{ClientGender}}, Age {{ClientAge}}</P></TD>
    </TR>
    <TR>
        <TD><P class="p-left content">Underwriting Class</P></TD>
        <TD><P class="p-right content"><NOBR>{{UnderwritingClass}}</NOBR></P></TD>
    </TR>
    {{CirUWClassRow}}
    {{Rating_Flat_Extra}}
    <TR>
      <TD colspan=2>
          <P class="p-center sub-heading-center">All coverages, premiums, riders and underwriting classes are subject to Home Office approval.</P>
          <P class="p-center sub-heading-center">You may be required to provide medical information, and an exam may be necessary.</P>
      </TD>
    </TR>
    <TR>
      <TD colspan=2><P class="p-center sub-heading-center">Policy Information</P></TD>
    </TR>
    <TR>
        <TD><P class="p-left content">Issuing Company</P></TD>
        <TD><P class="p-right content nobr">Massachusetts Mutual Life Insurance Company</P></TD>
    </TR>
    <TR>
        <TD><P class="p-left content">Policy</P></TD>
        <TD><P class="p-right nobr">{{PRODUCT_NAME}} with premiums {{PRODUCT_PAYABLE_COPY}}</P></TD>
    </TR>
    <TR>
        <TD><P class="p-left content">Generic Policy Name</P></TD>
        <TD><P class="p-right content nobr">{{GenericPolicyName}}</P></TD>
    </TR>
    <TR>
        <TD><P class="p-left content">Policy Form Number</P></TD>
        <TD><P class="p-right content"><NOBR>{{PolicyFormNumber}}</NOBR></P></TD>
    </TR>
    <TR>
        <TD><P class="p-left content">MEC Status</P></TD>
        <TD><P class="p-right content">{{MECStatus}}</P></TD>
    </TR>
    <TR>
        <TD class="td-med"><P class="p-left content">Initial Base Dividend Option</P></TD>
        <TD class="td-med"><P class="p-right content">{{DividendOption}}</P></TD>
    </TR>
    </TABLE>
    <TABLE id="page-table_2" class="full-width page-table" cellpadding=0 cellspacing=0>
    <TR>
        <TD colspan=2><P class="p-center sub-heading-center">Initial Premium Information</P></TD>
    </TR>
    <TR>
        <TD class="tr2"><P class="p-left content">Premium Payment Mode</P></TD>
        <TD class="tr2"><P class="p-right content">{{PremiumPaymentMode}}</P></TD>
    </TR>
    <TR>
        <TD class="td-med"><P class="p-left content">Base Premium</P></TD>
        <TD class="td-med"><P class="p-right content">{{BasePolicyPremium}}</P></TD>
    </TR>
    {{CirPremiumRow}}
    {{FlatExtraTableRow}}
    {{WaiverOfPremiumDividendTableRow}}
    {{GirPremiumRow}}
    {{RtrPremiumRow}}
    {{AlirPremiumRow}}
    {{AlirUnscheduledFirstYearLumpSumRow}}

    <TR>
        <TD class="td-med"><P class="p-left content">Accelerated Death Benefit for Terminal Illness Rider</P></TD>
        <TD class="td-med"><P class="p-right content">No Premium Charge</P></TD>
    </TR>
    <TR>
        <TD class="td-med"><P class="p-left ft15">&nbsp;</P></TD>
        <TD class="td-med"><P class="p-right content">_________________</P></TD>
    </TR>
    <TR>
        <TD class="td-large"><P class="p-left content">Total Initial Premium</P></TD>
        <TD class="td-large"><P class="p-right content">{{TotalInitialPremium}}</P></TD>
    </TR>
    {{Alir1035FootNoteRow}}
    {{CirFootNoteRow}}
    <TR>
        <TD colspan=2 class="tr8"><P class="p-center sub-heading-center">Initial Coverage Information</P></TD>
    </TR>
    <TR>
        <TD><P class="p-left content">Base Policy Face Amount</P></TD>
        <TD><P class="p-right content">{{BasePolicyFaceAmount}}</P></TD>
    </TR>
    {{RtrFaceAmountRow}}
    {{AlirScheduledCoverageAmount}}
    {{AlirUnscheduledCoverageAmountRow}}

    <TR>
        <TD><P class="p-left ft11">&nbsp;</P></TD>
        <TD><P class="p-right content">_________________</P></TD>
    </TR>
    <TR>
        <TD class="td-large"><P class="p-left content">Total Initial Death Benefit</P></TD>
        <TD class="td-large"><P class="p-right content">{{TotalInitialDeathBenefit}}</P></TD>
    </TR>
    {{CirBenefitOptionsBlock}}
    </TABLE>
      <BR/>
    </DIV>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    `,
  Supplemental_Client_Policy_Premium_Coverage_Info: `<DIV id="page_2">
  <P class="p-left content"><span class="content-bold-underline">MassMutual Whole Life {{PRODUCT}}</span> is a permanent life insurance policy providing a guaranteed face amount. Premiums are {{PRODUCT_PAYABLE_COPY}}. This illustration is neither a projection nor estimate of future benefits and assumes that the currently illustrated non-guaranteed elements will continue unchanged for all years shown. This is not likely to occur. Actual results may be more or less favorable than those shown.</P>
  <TABLE id="page-table_1" class="full-width page-table" cellpadding=0 cellspacing=0>
  {{LowerDividendWarning}}
  <TR>
      <TD colspan=2><P class="p-center sub-heading-center">Client Information</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Prepared for</P></TD>
      <TD><P class="p-right content nobr">{{ClientFirstName}} {{ClientLastName}}, {{ClientGender}}, Age {{ClientAge}}</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Underwriting Class</P></TD>
      <TD><P class="p-right content"><NOBR>{{UnderwritingClass}}</NOBR></P></TD>
  </TR>
  {{Rating_Flat_Extra}}
  <TR>
    <TD colspan=2>
        <P class="p-center sub-heading-center">All coverages, premiums, riders and underwriting classes are subject to Home Office approval.</P>
        <P class="p-center sub-heading-center">You may be required to provide medical information, and an exam may be necessary.</P>
    </TD>
  </TR>
  <TR>
    <TD colspan=2><P class="p-center sub-heading-center">Policy Information</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Issuing Company</P></TD>
      <TD><P class="p-right content nobr">Massachusetts Mutual Life Insurance Company</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Policy</P></TD>
      <TD><P class="p-right nobr">{{PRODUCT_NAME}} with premiums {{PRODUCT_PAYABLE_COPY}}</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Generic Policy Name</P></TD>
      <TD><P class="p-right content nobr">{{GenericPolicyName}}</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Policy Form Number</P></TD>
      <TD><P class="p-right content"><NOBR>{{PolicyFormNumber}}</NOBR></P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">MEC Status</P></TD>
      <TD><P class="p-right content">{{MECStatus}}</P></TD>
  </TR>
  <TR>
      <TD class="td-med"><P class="p-left content">Initial Base Dividend Option</P></TD>
      <TD class="td-med"><P class="p-right content">{{DividendOption}}</P></TD>
  </TR>
  </TABLE>
  <TABLE id="page-table_2" class="full-width page-table" cellpadding=0 cellspacing=0>
  <TR>
      <TD colspan=2><P class="p-center sub-heading-center">Initial Premium Information</P></TD>
  </TR>
  <TR>
      <TD class="tr2"><P class="p-left content">Premium Payment Mode</P></TD>
      <TD class="tr2"><P class="p-right content">{{PremiumPaymentMode}}</P></TD>
  </TR>
  <TR>
      <TD class="td-med"><P class="p-left content">Base Premium</P></TD>
      <TD class="td-med"><P class="p-right content">{{BasePolicyPremium}}</P></TD>
  </TR>
  {{FlatExtraTableRow}}
  {{WaiverOfPremiumDividendTableRow}}
  {{GirPremiumRow}}
  {{RtrPremiumRow}}
  {{AlirPremiumRow}}
  <TR>
      <TD class="td-med"><P class="p-left content">Accelerated Death Benefit for Terminal Illness Rider</P></TD>
      <TD class="td-med"><P class="p-right content">No Premium Charge</P></TD>
  </TR>
  <TR>
      <TD class="td-med"><P class="p-left ft15">&nbsp;</P></TD>
      <TD class="td-med"><P class="p-right content">_________________</P></TD>
  </TR>
  <TR>
      <TD class="td-large"><P class="p-left content">Total Initial Premium</P></TD>
      <TD class="td-large"><P class="p-right content">{{TotalInitialPremium}}</P></TD>
  </TR>
  <TR>
      <TD colspan=2 class="tr8"><P class="p-center sub-heading-center">Initial Coverage Information</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Base Policy Face Amount</P></TD>
      <TD><P class="p-right content">{{BasePolicyFaceAmount}}</P></TD>
  </TR>
  {{RtrFaceAmountRow}}
  {{AlirScheduledCoverageAmount}}
  <TR>
      <TD><P class="p-left ft11">&nbsp;</P></TD>
      <TD><P class="p-right content">_________________</P></TD>
  </TR>
  <TR>
      <TD class="td-large"><P class="p-left content">Total Initial Death Benefit</P></TD>
      <TD class="td-large"><P class="p-right content">{{TotalInitialDeathBenefit}}</P></TD>
  </TR>
  </TABLE>

  </DIV>
  <p>&nbsp;</p>
  `,
  Styles: `
        #page_2 {position:relative; overflow: hidden;margin: 0px 0px 0px 0px;padding: 0px;border: none;}
        .page-table {font: 11px 'Times New Roman';}
        .page-table tr td { vertical-align: center; height: 14px; }
        .clr {clear:both;float:none;height:4px;margin:0px;padding:0px;overflow:hidden;}
        .td-med{height: 15px;}
        .td-large{height: 20px;}
        .nobr {white-space: nowrap;}`,
  Flat_Extra: `<TR>
            <TD class="td-large"><P class="p-left content">Permanent Flat Extra Premium</P></TD>
            <TD class="td-large"><P class="p-right content">{{FlatExtraPremium}}</P></TD>
        </TR>`,
  Rating_Flat_Extra: `<TR>
            <TD><P class="p-left content left-indent">Ratings (Policy)</P></TD>
            <TD><P class="p-right content"><NOBR>Permanent Flat Extra Premium<NOBR></P></TD>
        </TR>`,
  Table_Rating: `<TR>
            <TD><P class="p-left content left-indent">Ratings (Policy)</P></TD>
            <TD class="td-large"><P class="p-right content">{{TableRatingStringCode}}</P></TD>
        </TR>`,
  Table_Rating_Flat_Extra: `<TR>
             <TD><P class="p-left ft11">&nbsp;</P></TD>
            <TD><P class="p-right content"><NOBR>Permanent Flat Extra Premium<NOBR></P></TD>
        </TR>`,
  Waiver_Of_Premium: `<TR>
            <TD class="td-large"><P class="p-left content">Waiver of Premium (WP)</P></TD>
            <TD class="td-large"><P class="p-right content">{{WaiverOfPremium}}</P></TD>
        </TR>`,
  Gir_Premium: `
    <TR>
      <TD class="td-med"><P class="p-left content">Guaranteed Insurability Rider (GIR) Premium</P></TD>
      <TD class="td-med"><P class="p-right content">{{GirPremium}}</P></TD>
    </TR>`,
  Rtr_Premium: `
    <TR>
      <TD class="td-med"><P class="p-left content">Renewable Term Rider (RTR) Premium</P></TD>
      <TD class="td-med"><P class="p-right content">{{RtrPremium}}</P></TD>
    </TR>`,
  Rtr_Face_Amount: `
    <TR>
      <TD><P class="p-left content">RTR Face Amount</P></TD>
      <TD><P class="p-right content">{{RtrFaceAmount}}</P></TD>
    </TR>`,
  Alir_Premium: `
    <TR>
      <TD class="td-med wider-content"><P class="p-left content nobr">Additional Life Insurance Rider (ALIR) Scheduled Purchase Payment</P></TD>
      <TD class="td-med"><P class="p-right content">{{AlirPremium}}</P></TD>
    </TR>`,
  Alir_Scheduled_Coverage_Amount: `
    <TR>
      <TD><P class="p-left content">ALIR Scheduled Coverage Amount (At Issue)</P></TD>
      <TD><P class="p-right content">{{AlirFaceAmount}}</P></TD>
    </TR>`,
  Alir_Unscheduled_First_Year_Lump_Sum: `
    <TR>
      <TD class="td-med wider-content"><P class="p-left content nobr">Additional Life Insurance Rider (ALIR) Unscheduled Payment*</P></TD>
      <TD class="td-med"><P class="p-right content">{{CashValueTransferAmount}}</P></TD>
    </TR>`,
  Alir_1035_Foot_Note: `
    <TR>
      <TD class="td-large"><P class="p-left content-cursive">* Assumes 1035 proceeds are applied {{TransferAmountArrivalTime}} after issue. If the 1035 funds are applied more than {{TransferAmountMaxArrivalTime}} after issue, the policy values will be lower than illustrated</P></TD>
    </TR>`,
  Alir_Unscheduled_Coverage_Amount: `
    <TR>
      <TD><P class="p-left content">ALIR Unscheduled Coverage Amount (Year 1)</P></TD>
      <TD><P class="p-right content">{{AlirUnscheduledAmount}}</P></TD>
    </TR>`,
  Has_Cir: ' with CIR',
  Cir_NS_Text: ' with an accelerated death benefit for Chronic Illness rider',
  Cir_UW_Class: `
    <TR>
      <TD><P class="p-left content">CIR Underwriting Class</P></TD>
      <TD><P class="p-right content"><NOBR>{{CirUnderwritingClass}}<NOBR></P></TD>
    </TR>`,
  Cir_Premium: `
    <TR>
      <TD class="td-med"><P class="p-left content">CIR Premium</P></TD>
      <TD class="td-med"><P class="p-right content">{{CirPremium}}</P></TD>
    </TR>`,
  Cir_Premium_WOP: `
    <TR>
      <TD class="td-med"><P class="p-left content">CIR Premium*</P></TD>
      <TD class="td-med"><P class="p-right content">{{CirPremium}}</P></TD>
    </TR>`,
  Cir_Foot_Note: `
    <TR>
      <TD class="td-large"><P class="p-left content-cursive">* The premium for the Waiver of Premium Rider above does not include the waiver of premium for CIR. The CIR waiver of premiums are included in the CIR premium.</P></TD>
    </TR>`,
  Cir_Benefit_Options: `
  <TR>
    <TD colspan=2><P class="p-center sub-heading-center">CIR Benefit Options</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Base Benefit Pool</P></TD>
      <TD><P class="p-right content">{{BaseBenefitPool}}</P></TD>
  </TR>
  <TR>
      <TD><P class="p-left content">Residual Face Amount</P></TD>
      <TD><P class="p-right content">{{ResidualFaceAmount}}</P></TD>
  </TR>
  <TR>
      <TD class="td-med wider-content"><P class="p-left content">Initial Monthly Benefit</P></TD>
      <TD class="td-med"><P class="p-right content">{{PayoutMethod}}</P></TD>
  </TR>
  <TR>
      <TD class="td-med wider-content"><P class="p-left content">Base{{HasAlirText}} Paid-up Additions Available for Acceleration</P></TD>
      <TD class="td-med"><P class="p-right content">{{BasePUAAvailable}}</P></TD>
  </TR>`,

  Title: 'Narrative Summary',
};
